import { LocalStorageKeys } from 'commons/local-storage';
import { StatusProps } from 'types';

function getIsAdminFromStorage() {
  try {
    return JSON.parse(localStorage.getItem(LocalStorageKeys.User) || '')
      .isAdmin;
  } catch (error) {
    return false;
  }
}

const isAdmin = getIsAdminFromStorage();

export const STATUSES: {
  [key: string]: StatusProps;
  AVAILABLE_FOR_STORE: StatusProps;
  RESERVED_BY_STORE: StatusProps;
  CONFIRMED_BY_STORE: StatusProps;
  RELEASE_PAYMENT: StatusProps;
  SHIPPED: StatusProps;
  READY_FOR_CUSTOMER_PICKUP_IN_STORE: StatusProps;
  READY_FOR_PICKUP_BY_DRIVER: StatusProps;
  PICKUP_BY_DRIVER: StatusProps;
  CLARIFY_DELIVERY_FAIL: StatusProps;
  COLLECT_FAIL: StatusProps;
  INVOICED: StatusProps;
  DELIVERED_BY_DRIVER: StatusProps;
  DELIVERED: StatusProps;
  MANUALLY_DELIVERED: StatusProps;
  CANCELLED: StatusProps;
  ABACOS_CONFIRMATION_RESPONSE_NOT_RECEIVED: StatusProps;
  NEW: StatusProps;
  NOT_DELIVERED: StatusProps;
  NOT_INTEGRATED: StatusProps;
  PAYMENT_CONFIRMED: StatusProps;
  READY: StatusProps;
  STORE_SHIPPING_CAPTURE_AMOUNT_PROBLEM: StatusProps;
  STORE_SHIPPING_PROBLEM: StatusProps;
  STORE_SHIPPING_PROBLEM_ANALYZING: StatusProps;
  WAIT_FOR_ABACOS_CONFIRMATION_RESPONSE: StatusProps;
  WAIT_FOR_RETURN_TO_STORE: StatusProps;
  WAIT_FOR_INVOICE: StatusProps;
} = {
  AVAILABLE_FOR_STORE: {
    value: 'AVAILABLE_FOR_STORE',
    label: 'Aguardando atendimento',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  RESERVED_BY_STORE: {
    value: 'RESERVED_BY_STORE',
    label: 'Em atendimento',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  CONFIRMED_BY_STORE: {
    value: 'CONFIRMED_BY_STORE',
    label: 'Venda registrada',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  RELEASE_PAYMENT: {
    value: 'RELEASE_PAYMENT',
    label: 'Liberando recebíveis',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  SHIPPED: {
    value: 'SHIPPED',
    label: 'Sinalizando transportador',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  READY_FOR_CUSTOMER_PICKUP_IN_STORE: {
    value: 'READY_FOR_CUSTOMER_PICKUP_IN_STORE',
    label: 'Aguardando cliente retirar',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  READY_FOR_PICKUP_BY_DRIVER: {
    value: 'READY_FOR_PICKUP_BY_DRIVER',
    label: 'Aguardando transportador coletar',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  PICKUP_BY_DRIVER: {
    value: 'PICKUP_BY_DRIVER',
    label: 'Em rota de entrega',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  CLARIFY_DELIVERY_FAIL: {
    value: 'CLARIFY_DELIVERY_FAIL',
    label: 'Falha na entrega',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  COLLECT_FAIL: {
    value: 'COLLECT_FAIL',
    label: 'Falha na coleta',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  INVOICED: {
    value: 'INVOICED',
    label: 'Faturado',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  DELIVERED_BY_DRIVER: {
    value: 'DELIVERED_BY_DRIVER',
    label: 'Entregue',
    storeFilter: true,
    initialStoreFilter: false,
    backofficeFilter: false,
    initialBackofficeFilter: true,
  },
  DELIVERED: {
    value: 'DELIVERED',
    label: 'Entregue',
    storeFilter: true,
    initialStoreFilter: false,
    backofficeFilter: false,
    initialBackofficeFilter: true,
  },
  MANUALLY_DELIVERED: {
    value: 'MANUALLY_DELIVERED',
    label: 'Entregue',
    storeFilter: true,
    initialStoreFilter: false,
    backofficeFilter: false,
    initialBackofficeFilter: true,
  },
  CANCELLED: {
    value: 'CANCELLED',
    label: 'Cancelado',
    storeFilter: isAdmin,
    initialStoreFilter: false,
    backofficeFilter: false,
    initialBackofficeFilter: true,
  },
  ABACOS_CONFIRMATION_RESPONSE_NOT_RECEIVED: {
    value: 'ABACOS_CONFIRMATION_RESPONSE_NOT_RECEIVED',
    label: 'Confirmação do Abacos não Recebida',
    storeFilter: false,
    initialStoreFilter: false,
    backofficeFilter: false,
    initialBackofficeFilter: false,
  },
  NEW: {
    value: 'NEW',
    label: 'Pedido Efetuado',
    storeFilter: false,
    initialStoreFilter: false,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  NOT_DELIVERED: {
    value: 'NOT_DELIVERED',
    label: 'Não entregue',
    storeFilter: false,
    initialStoreFilter: false,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  NOT_INTEGRATED: {
    value: 'NOT_INTEGRATED',
    label: 'Não integrado com o Abacos',
    storeFilter: false,
    initialStoreFilter: false,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  PAYMENT_CONFIRMED: {
    value: 'PAYMENT_CONFIRMED',
    label: 'Pagamento Confirmado',
    storeFilter: false,
    initialStoreFilter: false,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  READY: {
    value: 'READY',
    label: 'Criando remessa',
    storeFilter: false,
    initialStoreFilter: false,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  STORE_SHIPPING_CAPTURE_AMOUNT_PROBLEM: {
    value: 'STORE_SHIPPING_CAPTURE_AMOUNT_PROBLEM',
    label: 'Remessa com problema na captura',
    storeFilter: false,
    initialStoreFilter: false,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  STORE_SHIPPING_PROBLEM: {
    value: 'STORE_SHIPPING_PROBLEM',
    label: 'Remessa com problema',
    storeFilter: false,
    initialStoreFilter: false,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  STORE_SHIPPING_PROBLEM_ANALYZING: {
    value: 'STORE_SHIPPING_PROBLEM_ANALYZING',
    label: 'Remessa com problema em análise',
    storeFilter: false,
    initialStoreFilter: false,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  WAIT_FOR_ABACOS_CONFIRMATION_RESPONSE: {
    value: 'WAIT_FOR_ABACOS_CONFIRMATION_RESPONSE',
    label: 'Aguardando Confirmação do Abacos',
    storeFilter: false,
    initialStoreFilter: false,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  WAIT_FOR_RETURN_TO_STORE: {
    value: 'WAIT_FOR_RETURN_TO_STORE',
    label: 'Aguardando retorno para loja',
    storeFilter: false,
    initialStoreFilter: false,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
  WAIT_FOR_INVOICE: {
    value: 'WAIT_FOR_INVOICE',
    label: 'Aguardando emissão',
    storeFilter: true,
    initialStoreFilter: true,
    backofficeFilter: true,
    initialBackofficeFilter: true,
  },
};
